import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DefaultAppSetting } from '../models/DefaultAppSetting';

@Injectable({
  providedIn: 'root'
})
export class DefaultAppSettingService {


  constructor(private httpClient: HttpClient) { }

  find(): Observable<DefaultAppSetting[]> {
    return this.httpClient.get<DefaultAppSetting[]>(environment.apiUrl + "default-app-settings");
  }

  save(defaultAppSettings: DefaultAppSetting[]): Observable<DefaultAppSetting[]> {
    return this.httpClient.put<DefaultAppSetting[]>(environment.apiUrl + "default-app-settings", defaultAppSettings);
  }

}
